"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitesImport = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const button_1 = require("client/components/material/button");
const paper_1 = require("client/components/material/paper");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/sites/store");
const Backup_1 = require("material-ui-icons/Backup");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const ReactTooltip = require("react-tooltip");
require("./sites-import.less");
let SitesImport = class SitesImport extends react_1.Component {
    constructor() {
        super(...arguments);
        this.cacheRowIndex = -1;
        this.site = {}; // probably not needed.
        this.handleDrop = async (accepted) => {
            if (accepted.length) {
                await store_1.sitesStore.parseRow(accepted);
                store_1.sitesStore.importedFile = {
                    accepted
                };
                router_1.RouteManager.transitionTo(`/pharmacies/import/select`);
            }
        };
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    componentDidMount() {
        // console.log(sitesStore.submitted, sitesStore.submission);
    }
    render() {
        return (React.createElement("div", { className: "providers-submit" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("h2", null, "Import Pharmacies")),
            !store_1.sitesStore.submitted &&
                (!store_1.sitesStore.submission.value ||
                    store_1.sitesStore.submission.value.length === 0) && (React.createElement(paper_1.MaterialPaper, { className: "providers-submit__submission" },
                React.createElement(ui_1.UiDropzone, { className: "providers-submit__dropzone", onDrop: this.handleDrop, loading: store_1.sitesStore.submission.loading },
                    React.createElement(Backup_1.default, { className: "providers-submit__download-icon" }),
                    React.createElement("p", null,
                        React.createElement("strong", null, "Drag & Drop Pharmacies File"),
                        React.createElement("br", null),
                        React.createElement("small", null, "(.csv only)")),
                    React.createElement("div", { className: "providers-submit__dropzone-button" },
                        React.createElement(button_1.MaterialButton, { flat: true, className: "browse-button" }, "Browse to Upload"))))),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" })));
    }
};
__decorate([
    mobx_1.observable
], SitesImport.prototype, "site", void 0);
SitesImport = __decorate([
    mobx_react_1.observer
], SitesImport);
exports.SitesImport = SitesImport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-import/sites-import.tsx
// module id = 4078
// module chunks = 0